import axios from 'axios'
import { RootStore } from '../data/store'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const sampleBulkFileDownloadReq = (mid: string) => {
  const tokens = RootStore.user.session.getTokens
  const reqBody = {
    input: {
      merchantID: mid,
      responseType: 'DEFAULT',
      transactionType: 'BulkRefund',
    },
    configParams: {
      mediaType: 'XLSX',
    },
    outputDomains: ['fileDetails'],
  }
  return axios
    .post(`${sitConfig(tokens).baseUrl}${APIEndPoints.BulkRefundSampleFileDownload}`, reqBody, {
      headers: sitConfig(tokens).headers,
      responseType: 'arraybuffer',
    })
    .then((resp) => {
      return responseParser(resp)
    })
}

export { sampleBulkFileDownloadReq }
